'use client';

import Box from '@mui/material/Box';
import { useChartRootRef } from '@mui/x-charts/hooks';
import type { PropsWithChildren } from 'react';

export function ChartWrapper({ children }: PropsWithChildren) {
  const chartRootRef = useChartRootRef();

  return (
    <Box
      ref={chartRootRef}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: { xs: 'center', md: 'space-between' },
        gap: '32px',
        width: '100%',
      }}
    >
      {children}
    </Box>
  );
}
